import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

import translationJapanese from './locales/jp';
import translationKorean from './locales/ko';


const OPTIONS = [
  { label: '한국어', value: 'ko', languageIcon: 'koreaIcon' },
  { label: '日本語 (일본어)', value: 'jp', languageIcon: 'japanIcon' },
];

const LOCALES = {
  ko: translationKorean,
  jp: translationJapanese,
};

const DEFAULT_LOCALE = 'ko';



const LocaleContext = createContext({
  options: OPTIONS,
  locales: LOCALES.ko,
  currentLocale: OPTIONS[0],
  localePrefix: '',
  getLocale: () => '',
  setCurrentLocale: () => {},
});

export function LocaleProvider({ children }) {
  const [currentLocale, setCurrentLocaleState] = useState(OPTIONS[0]);

  useEffect(() => {
    const pathLocale = window.location.pathname.split('/').find((segment) => OPTIONS.some((o) => o.value === segment));
    if (pathLocale) {
      const found = OPTIONS.find((item) => item.value === pathLocale);
      if (found) { setCurrentLocaleState(found); return; }
    }
    const storedLocale = localStorage.getItem('locale');
    if (storedLocale) {
      const found = OPTIONS.find((item) => item.value === storedLocale);
      if (found) setCurrentLocaleState(found);
    }
  }, []);

  const setCurrentLocale = useCallback((locale) => {
    localStorage.setItem('locale', locale.value);
    setCurrentLocaleState(locale);
  }, []);

  const value = useMemo(() => {
    const getLocaleByOption = (locale, key) => {
      const keyArray = key.split('.');
      const localeByValue = LOCALES[locale || 'ko'];
      let result = {};

      keyArray.forEach((k, idx) => {
        if (idx === 0) {
          result = localeByValue[k];
        } else if (result !== undefined) {
          result = result[k];
        }
      });

      return result;
    };

    const getLocale = (key) => {
      const result = getLocaleByOption(currentLocale?.value, key);
      if (result === undefined) {
        return getLocaleByOption(DEFAULT_LOCALE, key);
      }
      return result;
    };

    return {
      options: OPTIONS,
      locales: LOCALES[currentLocale?.value || 'ko'],
      currentLocale,
      localePrefix: currentLocale?.value === 'ko' ? '' : `/${currentLocale?.value}`,
      getLocale,
      setCurrentLocale,
    };
  }, [currentLocale, setCurrentLocale]);

  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  return useContext(LocaleContext);
}
